import { Member } from '@rewardops/env'
import { EventBuilder, EventParams } from '@rewardops/utils'

import {
  GoogleAddPaymentInfoParams,
  GoogleAddToCartParams,
  GoogleBeginCheckoutParams,
  GoogleEventData,
  GoogleLocationSuggestionParams,
  GooglePurchaseParams,
  GoogleSelectItemParams,
  GoogleSelectPromotionParams,
  GoogleViewCartParams,
  GoogleViewItemListParams,
  GoogleViewItemParams,
  GoogleViewPromotionParams,
} from './google-event-transformer'

interface GoogleEventPayload {
  client_id: string
  events: Array<{ name: string; params: GoogleEventData }>
}

export const classMap: { [key: string]: new (...args: any[]) => any } = {
  select_item: GoogleSelectItemParams,
  view_item: GoogleViewItemParams,
  view_item_list: GoogleViewItemListParams,
  begin_checkout: GoogleBeginCheckoutParams,
  add_to_cart: GoogleAddToCartParams,
  purchase: GooglePurchaseParams,
  view_promotion: GoogleViewPromotionParams,
  select_promotion: GoogleSelectPromotionParams,
  view_cart: GoogleViewCartParams,
  add_payment_info: GoogleAddPaymentInfoParams,
  location_suggestion: GoogleLocationSuggestionParams,
}

export class GoogleEventBuilder implements EventBuilder {
  buildEvent(event: EventParams, member: Member): GoogleEventPayload {
    return {
      client_id: member.id || 'not-authenticated-user',
      events: [
        {
          name: event.type,
          params: this.buildPayload(event),
        },
      ],
    }
  }

  private buildPayload(event: EventParams): GoogleEventData {
    const EventClass = classMap[event.type]
    if (!EventClass) {
      throw new Error(`No class found for event type: ${event.type}`)
    }

    const paramsMapper = new EventClass(event.data)

    return paramsMapper.convertToGA4Format()
  }
}
